import { render, staticRenderFns } from "./suggestions.vue?vue&type=template&id=11732d44&scoped=true&"
import script from "./suggestions.vue?vue&type=script&lang=js&"
export * from "./suggestions.vue?vue&type=script&lang=js&"
import style0 from "./suggestions.vue?vue&type=style&index=0&id=11732d44&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11732d44",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {InputsInput: require('/var/www/components/inputs/input.vue').default})
